import {
  FrameOptions,
  TextFrameOptions,
  ButtonOptions,
  TexturePack,
  SelectOptions,
  CheckBoxOptions,
  TitleOptions,
  InputOptions,
  HealthProgressBarOptions,
} from '../interface';

export const enum FRAME_THEME {
  DEFAULT,
  BLACK,
  BLUE,
}

export const FRAME_TEXTURE_PACK: Record<FRAME_THEME, TexturePack> = {
  [FRAME_THEME.DEFAULT]: {
    texture: '/textures/ui/frame/default.png',
    width: 4,
    height: 4,
  },
  [FRAME_THEME.BLACK]: {
    texture: '/textures/ui/frame/black.png',
    width: 4,
    height: 4,
  },
  [FRAME_THEME.BLUE]: {
    texture: '/textures/ui/frame/blue.png',
    width: 4,
    height: 4,
  },
};

export const DEFAULT_FRAME_OPTIONS: FrameOptions = {
  theme: FRAME_THEME.DEFAULT,
  width: 0,
  height: 0,
  margin: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
};

export const DEFAULT_TEXT_FRAME_OPTIONS: TextFrameOptions = {
  ...DEFAULT_FRAME_OPTIONS,
  fontSize: 12,
  fill: 0x633900,
};

export const DEFAULT_BUTTON_OPTIONS: ButtonOptions = {
  ...DEFAULT_TEXT_FRAME_OPTIONS,
  outlineColor: 0xffffff,
  outlineWidth: 1,
  outlineQuality: 0.1,
};

export const DEFAULT_INPUT_OPTIONS: InputOptions = {
  ...DEFAULT_TEXT_FRAME_OPTIONS,
  outlineColor: 0xffffff,
  outlineWidth: 1,
  outlineQuality: 0.1,
};

export const DEFAULT_SELECT_OPTIONS: SelectOptions<null> = {
  ...DEFAULT_BUTTON_OPTIONS,
  values: [],
  arrowColor: 0x633900,
  multiple: false,
};

export const DEFAULT_CHECKBOX_OPTIONS: CheckBoxOptions = {
  size: 4,
  boxStrokeWidth: 1,
  boxStrokeColor: 0x000000,
  boxFillColor: 0x202020,
  checkStrokeWidth: 1,
  checkStrokeColor: 0x2040bb,
  checkFillColor: 0x4060cc,
  defaultValue: false,
};

export const DEFAULT_TITLE_OPTIONS: TitleOptions = {
  fill: 0xffffff,
  backgroundColor: 0x101010,
  backgroundAlpha: 0.7,
  strokeColor: 0xffffff,
  strokeWidth: 2,
  strokeAlpha: 0.7,
};

export const enum TITLE_STATE {
  READY,
  PROGRESS,
}

export enum PROGRESS_BAR_TYPE {
  VERTICAL,
  HORIZONTAL,
}

export const DEFAULT_HEALTH_PROGRESS_BAR_OPTIONS: HealthProgressBarOptions = {
  width: 10,
  height: 10,
  value: 0,
  maxValue: 1,
  coefficient: 0.1,
  type: PROGRESS_BAR_TYPE.HORIZONTAL,
};

export const TITLE_DURATION = 60;
